import { render, staticRenderFns } from "./scrim.vue?vue&type=template&id=a1d80d46&functional=true&"
import script from "./scrim.vue?vue&type=script&lang=js&"
export * from "./scrim.vue?vue&type=script&lang=js&"
import style0 from "./scrim.vue?vue&type=style&index=0&id=a1d80d46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports